const excludeProductId = (products, productIds) => {
    if (!productIds || productIds.length === 0)
        return products;
    return products.filter(product => !productIds.includes(product.id));
};
export default excludeProductId;
//# sourceMappingURL=excludeProductId.js.map